var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 7.5C26.25 6.80965 25.6903 6.25 25 6.25H5C4.30962 6.25 3.75 6.80965 3.75 7.5C3.75 8.19035 4.30962 8.75 5 8.75H25C25.6903 8.75 26.25 8.19035 26.25 7.5ZM26.25 15C26.25 14.3096 25.6903 13.75 25 13.75H12.5C11.8096 13.75 11.25 14.3096 11.25 15C11.25 15.6904 11.8096 16.25 12.5 16.25H25C25.6903 16.25 26.25 15.6904 26.25 15ZM26.25 22.5C26.25 21.8096 25.6903 21.25 25 21.25H6.05769C5.36734 21.25 4.80769 21.8096 4.80769 22.5C4.80769 23.1904 5.36734 23.75 6.05769 23.75H25C25.6903 23.75 26.25 23.1904 26.25 22.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.5dc148cbce52b71e3e51c5db5bebca0f.svg";
export { ForwardRef as ReactComponent };